import React from 'react'

function MenuHero() {
  return (
    <div className="menu-hero">
      <h1 className="hero-title">Menu</h1>
    </div>
  );
}

export default MenuHero